import ThemeModal from './ThemeModal';

export default ThemeModal;
